import { gql } from "@apollo/client";

const GET_LANGUAGE_DATA_CACHE = gql`
  query GetLanguageDataCache {
    languageDataCache @client
  }
`;

export default GET_LANGUAGE_DATA_CACHE;
